import type {BlobLayoutStyledBlobPayload} from '@github-ui/code-view-types'
import React from 'react'

const CurrentStyledBlobContext = React.createContext({} as BlobLayoutStyledBlobPayload)

const defaultBlob: BlobLayoutStyledBlobPayload = {
  colorizedLines: null,
  rawLines: null,
  stylingDirectives: undefined,
}

export function CurrentStyledBlobProvider({
  blob,
  children,
}: React.PropsWithChildren<{blob?: BlobLayoutStyledBlobPayload}>) {
  return <CurrentStyledBlobContext value={blob ?? defaultBlob}> {children} </CurrentStyledBlobContext>
}

export function useCurrentStyledBlob() {
  return React.use(CurrentStyledBlobContext)
}
